<template>
  <div class="login-container" @keyup.enter="login">
    <img :src="pcLogo" alt="logo" :class="{
      'login-logo': VUEAPPWEBSETESIGN === 'ps',
      'login-lt-logo': VUEAPPWEBSETESIGN === 'lt',
    }">
    <div :class="{
      'login-logo-app': VUEAPPWEBSETESIGN === 'ps',
      'login-logo-lt': VUEAPPWEBSETESIGN === 'lt'
    }">
      <img :src="h5Logo" alt="logo" class="logo-app">
    </div>
    <div class="form-box">
      <div class="form-title">{{ isCheckedEmail? $t("auth.setPassword") : $t("auth.forgetPasswordEmail") }}</div>
      <div class="form-tip" v-show="isCheckedEmail">
        <img src="@/assets/images/login/alarm-clock.svg" alt="alarm clock">
        <span>
          The password must be at least 8 characters and include a number, a lowercase letter, an uppercase letter, and at least one of the supported symbols !@#$%^&*-
        </span>
      </div>
      <el-form @submit.native.prevent ref="form" class="form-container" v-show="!isCheckedEmail" onclick="return false">
        <div class="va-row">
          <div class="flex md12 w-100">
            <div class="label-title">
              <span class="label-title-text">{{ $t("auth.businessEmail") }}</span>
            </div>
            <div :class="{'has-error': errors.has('Business Email'), 'valid': isFormFieldValid('Business Email')}">
              <el-input
                v-model="confirmForm.email"
                name="Business Email"
                v-validate="'required|email'"
                required
                data-vv-validate-on="change"
                autocomplete="off"
                class="login-form-input"
                :class="{ 'input-error': errors.first('Business Email') }"
              />
              <small v-show="errors.has('Business Email')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('Business Email')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('Business Email') }}</span>
                </div>
              </small>
            </div>
          </div>
          <div class="back-to-login w-100">
            <p class="back-login">
              <span @click="backToLogin">{{ $t("backToLoginPage") }}</span>
            </p>
          </div>

          <div class="flex md12 w-100 form-submit">
            <el-button type="primary" @click="checkOutEmail" :disabled="!(confirmForm.email && errors.items.length === 0)">
              {{ $t("auth.confirm") }}
            </el-button>
          </div>
        </div>
      </el-form>

      <el-form @submit.native.prevent ref="form" class="form-container" v-show="isCheckedEmail" onclick="return false">
        <div class="va-row">
          <div class="flex md12 w-100">
            <div class="label-title">
              <span class="label-title-text">{{ $t('auth.password') }}</span>
            </div>
            <div :class="{'has-error': errors.has('Password'), 'valid': isFormFieldValid('Password')}" class="password-container">
              <el-input
                v-model="forgetFrom.password"
                name="Password"
                autocomplete="new-password"
                v-validate="'required|verifyPassword|validPassword'"
                required
                class="login-form-password"
                :type="isOpen ? 'text' : 'password'"
                :class="{ 'input-error': errors.first('Password') }"
                onkeyup="value=value.replace(/\s/g,'')"
                onkeydown="value=value.replace(/\s/g,'')"
              />
              <small v-show="errors.has('Password')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('Password')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('Password') }}</span>
                </div>
              </small>
              <div class="eye-password">
                <img :src="closeEye" alt="" @click="() => { isOpen = true }" v-if="!isOpen" />
                <img :src="openEye" alt="" @click="() => { isOpen = false }" v-if="isOpen" />
              </div>
            </div>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title">
              <span class="label-title-text">{{ $t('auth.confirmPassword') }}</span>
            </div>
            <div :class="{'has-error': errors.has('Confirm Password'), 'valid': isFormFieldValid('Confirm Password')}" class="password-container">
              <el-input
                v-model="forgetFrom.confirmPassword"
                name="Confirm Password"
                autocomplete="new-password"
                v-validate="'required|verifyConfirmPassword|validPassword'"
                required
                class="login-form-password"
                :type="isConfirmOpen ? 'text' : 'password'"
                :class="{ 'input-error': errors.first('Confirm Password') }"
                onkeyup="value=value.replace(/\s/g,'')"
                onkeydown="value=value.replace(/\s/g,'')"
              />
              <small v-show="errors.has('Confirm Password')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('Confirm Password')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('Confirm Password') }}</span>
                </div>
              </small>
              <div class="eye-password">
                <img :src="closeEye" alt="" @click="() => { isConfirmOpen = true }" v-if="!isConfirmOpen" />
                <img :src="openEye" alt="" @click="() => { isConfirmOpen = false }" v-if="isConfirmOpen" />
              </div>
            </div>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title d-flex align--end justify--space-between">
              <span class="label-title-text">{{ $t('auth.verficationCode') }}</span>
              <span class="valid-time">Valid for {{remainingTime}} minutes</span>
            </div>
            <div :class="{'has-error': errors.has('VerficationCode'), 'valid': isFormFieldValid('VerficationCode')}">
              <el-input
                v-model="forgetFrom.verficationCode"
                name="VerficationCode"
                autocomplete="off"
                v-validate="'required'"
                required
                class="login-form-input"
                :class="{ 'input-error': errors.first('VerficationCode') }"
              />
              <small v-show="errors.has('VerficationCode')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('VerficationCode')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('VerficationCode') }}</span>
                </div>
              </small>
            </div>
          </div>
          <div class="back-to-login w-100">
            <p class="back-login">
              <span @click="backToLogin">{{ $t("backToLoginPage") }}</span>
            </p>
          </div>

          <div class="flex md12 w-100 form-submit">
            <el-button type="primary" @click="resetPassword" :disabled="!(forgetFrom.password && forgetFrom.confirmPassword && forgetFrom.verficationCode && errors.items.length === 0)">
              {{ $t("auth.confirm") }}
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import qs from "qs";
import { request } from "@/utils/utils";
import pageName from "../../NewUser/pageNames";
import Spinner from "vue-simple-spinner";
const Base64 = require("js-base64").Base64;

export default {
  name: 'login',
  components: { Spinner },
  data () {
    return {
      confirmForm: {
        email: "",
      },
      forgetFrom: {
        password: "",
        confirmPassword: "",
        verficationCode: ""
      },
      token: localStorage.getItem("Authorization"),
      isCheckedEmail: false,
      remainingTime: 0,
      closeEye: require('@/assets/images/login/close-eye.svg'),
      openEye: require('@/assets/images/login/open-eye.svg'),
      isOpen: false,
      isConfirmOpen: false,
    }
  },
  created() {
    this.isCheckedEmail = false;
  },
  computed: {
    VUEAPPWEBSETESIGN() {
      return process.env.VUE_APP_WEBSETE_SIGN || ''
    },
    pcLogo() {
      if (process.env.VUE_APP_WEBSETE_SIGN === 'ps') {
        return require(`@/assets/images/psImg/logo-pc.svg`)
      } else {
        return require(`@/assets/images/ltImg/logo-pc.png`)
      }
    },
    h5Logo() {
      if (process.env.VUE_APP_WEBSETE_SIGN === 'ps') {
        return require(`@/assets/images/psImg/logo-app.svg`)
      } else {
        return require(`@/assets/images/ltImg/logo-app.png`)
      }
    },
  },
  methods: {
    ...mapMutations(["changeLogin", "setUser"]),
    login(event) {
      if (event.keyCode === 13 || event.keyCode == 100) {
        if (!this.isCheckedEmail) {
          this.checkOutEmail();
        } else {
          this.resetPassword();
        }
      }
    },
    checkOutEmail() {
      let that = this;
      that.$validator.validateAll({'Business Email': that.confirmForm.email}).then(result => {
        if (result) {
          that.loadingFullScreen("resetLoading", "Loading...", "fa fa-hourglass-half");
          request({
            method: "post",
            url: `api/dashboard/forgot-password-booster`,
            data: {
              login_name: that.confirmForm.email
            },
            headers: {
              "Content-Type": "	application/json",
            }
          }).then(response => {
            if (response.data.code === "10000") {
              that.remainingTime = Math.ceil(response.data.data/60)
              that.isCheckedEmail = true
              that.$validator.reset()
            } else {
              that.$message({
                duration: 2000,
                message: response.data.msg,
                type: "error"
              });
            }
            that.resetLoading.close();
          }).catch(err => {
              that.$message({
                duration: 2000,
                message: "Opps something went wrong!",
                type: "error"
              });
              that.resetLoading.close();
            });

        }
      })
    },
    resetPassword() {
      let that = this;
      let resetData = {
        'Password': that.forgetFrom.password,
        'Confirm Password': that.forgetFrom.confirmPassword,
        VerficationCode: that.forgetFrom.verficationCode
      }
      that.$validator.validateAll(resetData).then(result => {
        if (result) {
          that.loadingFullScreen("resetLoading", "Loading...", "fa fa-hourglass-half");
          request({
            method: "post",
            url: `api/dashboard/verify-reset-code-booster`,
            data: {
              login_name: that.confirmForm.email,
              verify_code: that.forgetFrom.verficationCode,
              password: that.forgetFrom.password
            },
            headers: {
              "Content-Type": "	application/json",
            }
          }).then(response => {
            if (response.data.code === "10000") {
              that.$message({
                duration: 2000,
                message: "Reset password success",
                type: "success",
                onClose: () => {
                  window.location.href = `${location.origin}`
                }
              });
              // that.$router.push({path: "/auth/login"})
            } else {
              that.$message({
                duration: 2000,
                message: response.data.msg,
                type: "error"
              });
            }
            that.resetLoading.close();
          }).catch(err => {
              that.$message({
                duration: 2000,
                message: "Opps something went wrong!",
                type: "error"
              });
              that.resetLoading.close();
            });
        }
      })
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
					this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    backToLogin() {
      window.location.href = `${location.origin}`
    }
  },
  components: {
  },
  directives: {
  },
  mounted() {
    let that = this;
    this.$validator.extend('verifyPassword', {
      validate: (value, ref) => {
        that.forgetFrom.password = value
        that.$validator.validateAll({"Confirm Password": that.forgetFrom.confirmPassword})
        return true
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    this.$validator.extend('verifyConfirmPassword', {
      validate: (value, ref) => {
        that.forgetFrom.confirmPassword = value
        if (value != that.forgetFrom.password) {
          return false
        } else {
          return true
        }
      },
      getMessage: (field) => 'The ' + field + ' do not match with password.'
    })
    let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
    this.$validator.extend('validPassword', {
      validate: (value, ref) => {
        if (!regExpPassword.test(value)) {
          return false
        } else {
          return true
        }
      },
      getMessage: (field) => this.$t('t.newPasswordMustBe')
    })
  }
}
</script>

<style lang="scss">
.login-container {
  width: 480px;
  height: fit-content;
  .login-logo {
    width: auto;
    height: 32px;
    margin-bottom: 32px;
    display: block;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      display: none;
    }
  }
  .login-lt-logo {
    width: 138px;
    height: auto;
    margin-bottom: 32px;
    display: block;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      display: none;
    }
  }
  .login-logo-app {
    /* width: 160px;
    height: 48px; */
    margin-bottom: 24px;
    display: none;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      background: #FFFFFF3D;
      box-shadow: 0px 4px 4px 0px #0000001F;
      display: block;
      margin-left: 50%;
      transform: translate(-50%, 0);
      padding: 12px 24px;
      border-radius: 90px;
      color: #FFFFFF;
      width: fit-content;
      /* .logo-app {
      } */
    }
  }
  .login-logo-lt {
    margin-bottom: 24px;
    display: none;
    @media screen and (max-width: 1026px) {
      margin-left: 50%;
      transform: translate(-50%, 0);
      display: block;
      width: fit-content;
      .logo-app {
        width: 138px;
        height: auto;
      }
    }
  }
  .form-box {
    background-color: white;
    font-family: SpaceGrotesk-Regular;
    width: 100%;
    height: auto;
    border-radius: 36px;
    border: 1px solid #00000008;
    padding: 36px;
    box-shadow: 0px 0px 12px 0px #00000040;
    .form-title {
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      color: #000000;
      margin-bottom: 24px;
    }
    .form-tip {
      padding: 12px 14px;
      background-color: #fff0e1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        margin-right: 10px;
      }
      span {
        color: #FF9F43;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        word-wrap:break-word;
      }
    }
    .form-container {
      .label-title {
        margin-top: 24px;
        margin-bottom: 12px;
        font-weight: 400;
        .label-title-text {
          font-size: 18px;
          line-height: 22px;
          color: #000000;
        }
        .valid-time {
          font-size: 14px;
          line-height: 18px;
          color: #FF9F43;
        }
      }
      .text-danger {
        font-size: 14px;
        color: #BD0000 !important;
      }
      .back-to-login {
        margin-top: 24px;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        p {
          margin: 0;
        }
        p.back-login {
          text-align: left;
        }
        p.back-login span {
          cursor: pointer;
          color: #007D59;
        }
      }

      .form-submit {
        margin-top: 24px;
        button {
          width: 100%;
          height: 48px;
          text-align: center;
          border-radius: 12px;
          border: 1px solid $VUE_APP_COLOR_LOGIN;
          background-color: $VUE_APP_COLOR_LOGIN!important;
          font-weight: 700;
          font-size: 18px;
          letter-spacing: 0.72px;
          color: #FFFFFF;
          outline:none;
        }
        button:focus,
        button:active,
        button:hover {
          border: 1px solid $VUE_APP_COLOR_LOGIN2;
          background-color: $VUE_APP_COLOR_LOGIN2!important;
        }
        button:disabled {
          border: 1px solid $VUE_APP_COLOR_LOGIN;
          background-color: $VUE_APP_COLOR_LOGIN!important;
          color: #FFFFFF99;
        }
      }
      .login-form-input,
      .login-form-password {
        input {
          border-radius: 12px;
          background-color: #FFFFFF;
          border: 1px solid #0000001F;
          font-size: 16px;
          color: #343434;
        }
        input:hover {
          border: 1px solid #0000003D;
        }
        input:active {
          border: 1px solid #007D59;
        }
        input:focus {
          border: 1px solid #0000001F;
        }
      }
      .login-form-password {
        input {
          color: #000000;
        }
      }
      /* .input-error {
        input {
          color: #FF3232DB;
          border: 1px solid #FF32323D;
        }
      } */

      .password-container {
        position: relative;
        .eye-password {
          position: absolute;
          top: 8px;
          right: 12px;
          width: 18px;
          cursor: pointer;
          img {
            width: 100%;
            height: auto;
          }
        }
      }

      #g-recaptcha-container {
        margin-top: 24px;
        /* transform: scale(0.8);
        transform-origin: 0 0; */
      }
      .g-error {
        color: #ea5455;
      }
    }
  }
}

</style>
